import clsx from "clsx";

export const container = clsx("flex md:w-[800px] my-4 lg:my-16");
export const countrySection = clsx("text-sm lg:text-md p-6 pb-0 lg:p-0 lg:mb-10 lg:flex lg:justify-start");
export const countryContainer = clsx(container + " flex-col");
export const country = clsx("inline tracking-widest rounded-sm bg-gray text-xs font-bold p-2")
export const staffContainer = clsx(
    container + " flex-wrap md:justify-center justify-around",
);